<template>
    <div class="wallpaper" :class="{ 'dark-mode': isDarkMode, 'image-mode': mapType === 'image', 'solid-mode': mapType === 'solid' }">
        <!-- 裝飾性光點效果 -->
        <div class="wallpaper-overlay" v-if="mapType !== 'image'">
            <div class="wallpaper-glow wallpaper-glow-1"></div>
            <div class="wallpaper-glow wallpaper-glow-2"></div>
            <div class="wallpaper-glow wallpaper-glow-3"></div>
            <div class="wallpaper-glow wallpaper-glow-4"></div>
        </div>
        <!-- 頂部漸層邊框 -->
        <div class="wallpaper-border" v-if="mapType !== 'image'"></div>
    </div>
</template>

<script>
export default {
    name: 'WallpaperBackground',
    props: {
        isDarkMode: {
            type: Boolean,
            default: false
        },
        mapType: {
            type: String,
            default: ''
        }
    }
};
</script>

<style scoped lang="stylus">
.wallpaper
    position: fixed
    top: 0
    bottom: 0
    left: 0
    right: 0
    z-index: 1
    pointer-events: none
    overflow: hidden
    transition: background 0.3s ease

    // 圖片模式 - 亮色
    &.image-mode
        background: url('@shared/assets/pfd/PFD_bg.png') center center / cover no-repeat #EEEFEF
        animation: none

    // 圖片模式 - 暗色
    &.image-mode.dark-mode
        background: url('@shared/assets/pfd/PFD_bg_dark.png') center center / cover no-repeat #1a1d24
        animation: none

    // 純色模式 - 亮色
    &.solid-mode
        background: #EEEFEF
        animation: none
    
    // 純色模式 - 暗色
    &.solid-mode.dark-mode
        background: #1a2332
        animation: none

    // 亮色模式 - 多層漸變（球狀光點使用柔和色調）
    &:not(.image-mode):not(.solid-mode)
        background: 
            radial-gradient(circle at 20% 30%, rgba(139, 92, 246, 0.15) 0%, transparent 50%),
            radial-gradient(circle at 80% 70%, rgba(236, 72, 153, 0.15) 0%, transparent 50%),
            radial-gradient(circle at 50% 50%, rgba(59, 130, 246, 0.12) 0%, transparent 50%),
            linear-gradient(135deg, #f8fafc 0%, #f1f5f9 25%, #e2e8f0 50%, #cbd5e1 75%, #94a3b8 100%),
            linear-gradient(45deg, #fafafa 0%, #f5f5f5 50%, #e5e5e5 100%)
        background-size: 200% 200%, 200% 200%, 200% 200%, 200% 200%, 200% 200%
        animation: gradientShift 15s ease infinite, gradientShift2 20s ease infinite reverse

    // 暗色模式 - 多層漸變（球狀光點使用柔和色調）
    &.dark-mode:not(.image-mode):not(.solid-mode)
        background: 
            radial-gradient(circle at 20% 30%, rgba(139, 92, 246, 0.3) 0%, transparent 50%),
            radial-gradient(circle at 80% 70%, rgba(236, 72, 153, 0.3) 0%, transparent 50%),
            radial-gradient(circle at 50% 50%, rgba(59, 130, 246, 0.25) 0%, transparent 50%),
            linear-gradient(135deg, #0d1b2a 0%, #1b263b 25%, #415a77 50%, #1b263b 75%, #0d1b2a 100%),
            linear-gradient(45deg, #0a1628 0%, #1a2332 50%, #2d3748 100%)
        background-size: 200% 200%, 200% 200%, 200% 200%, 200% 200%, 200% 200%

    // 移動端調整
    @media (max-width: 768px)
        left: 0
        right: 0

// 背景裝飾層
.wallpaper-overlay
    position: absolute
    inset: 0
    overflow: hidden
    pointer-events: none

// 裝飾性光點
.wallpaper-glow
    position: absolute
    border-radius: 50%
    filter: blur(40px)
    animation: glowPulse 4s ease-in-out infinite

// 亮色模式光點顏色
.wallpaper-glow-1
    top: 15%
    left: 15%
    width: 400px
    height: 400px
    background: #8b5cf6 // purple-500
    opacity: 0.2
    animation-delay: 0s

.wallpaper-glow-2
    bottom: 15%
    right: 15%
    width: 480px
    height: 480px
    background: #3b82f6 // blue-500
    opacity: 0.2
    animation-delay: 1s

.wallpaper-glow-3
    top: 50%
    right: 25%
    width: 360px
    height: 360px
    background: #ec4899 // pink-500
    opacity: 0.2
    animation-delay: 2s

.wallpaper-glow-4
    top: 30%
    right: 15%
    width: 320px
    height: 320px
    background: #ffffff // white
    opacity: 0.15
    animation-delay: 1.5s

// 暗色模式光點顏色
.wallpaper.dark-mode
    .wallpaper-glow-1
        background: #7c3aed // purple-600
        opacity: 0.25

    .wallpaper-glow-2
        background: #2563eb // blue-600
        opacity: 0.25

    .wallpaper-glow-3
        background: #db2777 // pink-600
        opacity: 0.25

    .wallpaper-glow-4
        background: #ffffff // white
        opacity: 0.2

// 頂部漸層邊框
.wallpaper-border
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 2px
    z-index: 20
    transition: background 0.3s ease

    // 亮色模式邊框
    background: linear-gradient(to right, #3b82f6, #8b5cf6, #ef4444) // blue-500, purple-500, red-500

    // 暗色模式邊框
    .wallpaper.dark-mode &
        background: linear-gradient(to right, #60a5fa, #a78bfa, #f472b6) // blue-400, purple-400, pink-400

@keyframes gradientShift
    0%
        background-position: 0% 50%, 100% 50%, 50% 50%, 0% 50%, 0% 0%
    50%
        background-position: 100% 50%, 0% 50%, 50% 50%, 100% 50%, 100% 100%
    100%
        background-position: 0% 50%, 100% 50%, 50% 50%, 0% 50%, 0% 0%

@keyframes gradientShift2
    0%
        background-position: 50% 0%, 50% 100%, 0% 50%, 50% 50%, 100% 0%
    50%
        background-position: 50% 100%, 50% 0%, 100% 50%, 50% 50%, 0% 100%
    100%
        background-position: 50% 0%, 50% 100%, 0% 50%, 50% 50%, 100% 0%

@keyframes glowPulse
    0%, 100%
        transform: scale(1)
    50%
        transform: scale(1.15)
</style>

